export default {"src":"/_next/static/image/public/images/ic_refund_green.46d4a281a1bdf5b64366c40d32f1a55c.svg","height":32,"width":32};